import React, { useEffect, useRef, useState } from 'react';
import { translate, termsSort, fragmentsSort } from '../../assets/js/functions';
import { Link } from 'react-router-dom'
import { getExploreTermsQue, getExploreTermsQui, getExploreTermsOn, getExploreTermsQuant, getThematicIndexations, getFragmentfromIndexLocator } from '../../assets/js/api';
import LayoutDefaultDark from "../../components/Layout/DefaultDark";
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import TermTree from '../../components/Terms/TermTree';
import Lateral from '../../components/Terms/Lateral';

export default function TimeLine(props){

    const title = translate("Temes")
    const [option, setOption] = useState(null);
    const [data, setData] = useState(null);
    const [selectedTerm, setSelectedTerm] = useState(null);
    const [loadingTerm, setLoadingTerm] = useState(false);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => { isMounted.current = false; };
    }, []);

    function updateSelectedTerm(term) {
        setSelectedTerm(null);
        if (term === null) {
            setLoadingTerm(false);
            return;
        }
        setLoadingTerm(true);

        const promise = term.indexation.map(
            i => {
                return getFragmentfromIndexLocator(JSON.stringify(i)).then(
                    interview => {
                        return interview.data.result;
                    }
                )
            }
        )
        Promise.all(promise).then(
            response => {
                let fragments = []
                let terms = []
                let have = [term.term_id];
                response.map(value => {
                    if (value[0].result && value[1].result && value[1].result.length > 0) {
                        fragments.push([value[0].result, value[1].result[0]]);
                        if (value[0].result.terms.length > 0) {
                            value[0].result.terms.map(term => {
                                if (!have.includes(term.term_id)) {
                                    terms.push(term);
                                    have.push(term.term_id);
                                }
                            })

                        }
                    }
                });
                term.combina = terms.length > 0?termsSort(terms):null;
                term.fragments = fragments.length > 0?fragmentsSort(fragments):null;
                if (isMounted.current) {
                    setLoadingTerm(false);
                    if (terms.length > 0 || fragments.length > 0) {
                        setSelectedTerm(term);
                    }
                }
            }
        )
    }

/*
3a/ “Què”= Thesaurus de Preservem la memòria [ts1_21984]
3b/ “Qui”= Personal sanitari [on1_4], Persones [on1_98]
3c/ “On”= (igual que en el cas dels mapes)  “Entitats i escoles educatives” [on1_5] i “Equipaments sanitaris” [on1_22]
3d/ “Quan”= (igual que en la línia de temps)  “Descriptors cronològics" [hierachy1_251].

getExploreTermsQue
getExploreTermsQui
getExploreTermsOn
getExploreTermsQuant
*/

    function resetChilds()
    {
        const newChilds = data.map(value => {
            value.show = false;
            return value;
        })
        setData(newChilds);
    }

    function showChildTerm(term, show)
    {
        const newChilds = data.map(value => {
            if (value.term_id === term.term_id) {
                value.show = show;
            }
            return value;
        })
        setData(newChilds);
    }

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://unpkg.com/leaflet@1.6.0/dist/leaflet.js";
        script.async = true;
        //script.onload = () => scriptLoaded();
        document.body.appendChild(script);

        const style = document.createElement("link");
        style.type = "text/css";
        style.rel = "stylesheet";
        style.href = "https://unpkg.com/leaflet@1.6.0/dist/leaflet.css";
        document.head.appendChild(style);

        setOption(props.match.params.id);
        if (props.match.params.id === 'qui') {
            getExploreTermsQui().then(res => {
                if (isMounted.current) setData(res);
            });
        } else if (props.match.params.id === 'on') {
            getExploreTermsOn().then(res => {
                if (isMounted.current) setData(res);
            });
        } else if (props.match.params.id === 'quan') {
            getExploreTermsQuant().then(res => {
                if (isMounted.current) setData(res);
            });
        } else {
            getExploreTermsQue().then(res => {
                if (isMounted.current) setData(res);
            });
        }

        setSelectedTerm(null);
        setLoadingTerm(!!props.match.params.term);

        if (props.match.params.term) {
            getThematicIndexations(props.match.params.term).then(res => {
                const result = res.data.result && res.data.result.length > 0 ? res.data.result[0] : null;
                if (!result) {
                    if (isMounted.current) setLoadingTerm(false);
                    return;
                }
                result.indexation = JSON.parse(result.indexation);
                //setSelectedTerm(result);
                const promise = result.indexation.map(
                    i => {
                        return getFragmentfromIndexLocator(JSON.stringify(i)).then(
                            interview => {
                                return interview.data.result;
                            }
                        )
                    }
                )
                Promise.all(promise).then(
                    response => {
                        let fragments = []
                        let terms = []
                        let have = [props.match.params.term];
                        response.map(value => {
                            if (value[0].result && value[1].result && value[1].result.length > 0) {
                                fragments.push([value[0].result, value[1].result[0]]);
                                if (value[0].result.terms.length > 0) {
                                    value[0].result.terms.map(term => {
                                        if (!have.includes(term.term_id)) {
                                            terms.push(term);
                                            have.push(term.term_id);
                                        }
                                    })

                                }
                            }
                        });
                        result.location_map = JSON.parse(result.location_map);
                        result.combina = terms.length > 0?termsSort(terms):null;
                        result.fragments = fragments.length > 0?fragmentsSort(fragments):null;
                        if (isMounted.current) {
                            updateSelectedTerm(result);
                        }
                    }
                )
            });

        }

    }, [props.match.params.id]);


    return (
        <LayoutDefaultDark pageMeta={{
            title: title,
            customCssClass: 'tesaure'
        }}>
            <Breadcrumbs currentSite={title} customCssClass="blanc"/>

            <div className="wrapper">
            <div className="columns is-multiline">
                <div className="column pr-l mb-s is-6-desktop is-12-touch">
                    <nav className="navigation" aria-label="Menú tesaure">
                        <ul className="tesaure-nav is-size-7-fullhd is-size-8-widescreen is-size-9-desktop is-size-7-touch is-7" role="list">
                            <li key="que" className={(option === 'que')?'current is-size-6-mobile':''}>
                                <Link to="/terms/que" className="is-flex is-align-items-center">
                                    <svg className="mr-xs" width="39px" height="40px" viewBox="0 0 39 40" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g transform="translate(-144, -245)" fill="#809fa5">
                                                <g  transform="translate(144, 245)">
                                                    <polygon fillRule="nonzero" points="17.2765898 17.2970836 17.2770222 9.72962365 21.6013468 9.72983986 21.6009144 17.2970836 29.1689149 17.2970836 29.1689149 21.6214083 21.6006982 21.6214083 21.6002658 29.1887601 17.2759411 29.1885439 17.2763736 21.6214083 9.70945413 21.6214083 9.70945413 17.2970836"></polygon>
                                                    <path d="M8.4369135,33.5037875 C11.0837245,35.8943822 13.9831842,37.8681121 17.2571303,39.4244365 C19.0107521,40.2580582 21.0906441,40.1820582 22.7718334,39.2230311 C25.6074012,37.6055175 28.075077,35.6588146 30.4611312,33.5037875 C35.5188613,28.9355709 38.467294,22.6484354 38.6610237,16.0183808 L38.8868616,8.28746138 C38.9131318,7.38756943 38.8881588,5.40540713 38.8881588,5.40540713 C37.756375,5.21859631 36.6120506,5.08162332 35.4693478,4.94475845 C31.9346449,4.52151518 28.415077,4.10015299 25.3264282,2.21239069 L23.1232929,0.865860871 C21.2343198,-0.288614885 18.8104277,-0.288625696 16.9215627,0.865860871 L14.8118329,2.15532042 C11.2809137,4.31336381 6.9769134,4.72238006 2.81098878,5.11827198 C1.86732385,5.2078936 0.930750815,5.29686658 0.0118534543,5.40540713 C0.0118534543,5.40540713 -0.0148168178,7.39946132 0.0118534543,8.31211004 L0.236999416,16.0183808 C0.430707537,22.6484354 3.37909693,28.9355709 8.4369135,33.5037875 Z M2.16239414,7.35340727 C2.16321577,7.69762351 2.16630766,8.01697488 2.17308604,8.2489749 L2.39824281,15.9552457 C2.57421039,21.9778407 5.25237274,27.7139492 9.88610279,31.8991387 C12.38513,34.1562199 15.1105356,36.0099498 18.1854547,37.4716796 C19.3027521,38.0028148 20.6359414,37.9523283 21.700482,37.3449769 C24.3547524,35.8309228 26.6944283,33.9922199 29.0118338,31.8991387 C33.645672,27.7139492 36.3237262,21.9778407 36.4997263,15.9551376 L36.7255641,8.22432625 C36.7326992,7.98227217 36.7358344,7.64259648 36.7365911,7.27870456 C36.230537,7.21351536 35.7165911,7.15200185 35.1911856,7.08908292 L35.1322667,7.0820559 C33.9698882,6.94281264 32.7512936,6.79600182 31.540807,6.5905964 C29.1148609,6.1789207 26.5768066,5.51059633 24.1988605,4.05725569 L21.9957252,2.71073667 C20.7989684,1.9793096 19.2458872,1.9793096 18.0491304,2.71073667 L15.9394005,4.00019622 C13.4328057,5.53221795 10.6638326,6.25816395 7.99712968,6.68735317 C6.34329173,6.95351535 4.56199431,7.12367752 2.89310771,7.2832451 C2.64683742,7.30670456 2.40301038,7.33005591 2.16239414,7.35340727 Z"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <span className={(option === 'que')?'is-flex-grow-1':''}>{ translate('Què') }</span>
                                    {(option === 'que')?
                                    <svg className="mr-s" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                                            <g transform="translate(-1645.000000, -92.000000)" stroke="#013F4C" strokeWidth="3">
                                                <g transform="translate(1656.957134, 104.000000) scale(1, -1) translate(-1656.957134, -104.000000) translate(1647.000000, 94.000000)">
                                                    <path d="M0,0 C12.6095123,13.3333333 18.9142684,20 18.9142684,20 C18.9142684,20 12.6095123,13.3333333 0,0 Z"></path>
                                                    <path d="M1,0 C13.6095123,13.3333333 19.9142684,20 19.9142684,20 C19.9142684,20 13.6095123,13.3333333 1,0 Z" transform="translate(10.457134, 10.000000) scale(-1, 1) translate(-10.457134, -10.000000) "></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    : ''}
                                </Link>
                            </li>
                            <li key="qui" className={(option === 'qui')?'current is-size-6-mobile':''}>
                                <Link to="/terms/qui" className="is-flex is-align-items-center">
                                    <svg className="mr-2xs qui-icon" width="40" height="40" viewBox="0 0 40 36.25">
                                        <g fill="none" fillRule="evenodd">
                                            <path fill="#809fa5" fillRule="nonzero" d="M31.111 27.361h2.222v2.222h-2.222v2.222h-2.222v-2.222h-2.222v-2.222h2.222v-2.222h2.222z"/><path fill="#809fa5" d="M12.087 20.694S0 24.464 0 28.991v7.259h40v-7.26c0-4.525-12.087-8.296-12.087-8.296l-6.636 4.66a2.222 2.222 0 0 1-2.554 0l-6.636-4.66Zm16.18 2.466-5.713 4.012a4.445 4.445 0 0 1-5.108 0l-5.714-4.012c-.223.08-.477.171-.754.275-1.09.408-2.523.99-3.942 1.699-1.44.718-2.759 1.515-3.685 2.324-1.001.875-1.129 1.395-1.129 1.533v5.037h35.556V28.99c0-.138-.128-.658-1.129-1.533-.927-.81-2.245-1.606-3.685-2.324a41.995 41.995 0 0 0-3.942-1.699 47.79 47.79 0 0 0-.754-.275Z"/>
                                            <g transform="translate(0 1.25)">
                                                <path stroke="#809fa5" fill="none" strokeWidth="2.5" d="M7.341 22.587v-4.303c0-2.24.5-18.284 12.5-18.284 12.001 0 12.5 16.487 12.5 18.284v4.17"/>
                                            </g>
                                            <path className="object" stroke="#809fa5" strokeLinejoin="round" strokeWidth="2.5" d="M12.5 12.54c0 3.229 2.529 7.257 7.24 7.257 4.713 0 6.76-3.035 6.76-6.36 0-3.326-1.873-6.458-4.291-7.062-.217 0 .536 1.863-2.569 4.281-3.104 2.419-7.14 1.884-7.14 1.884Z"/>
                                        </g>
                                    </svg>
                                    <span className={(option === 'qui')?'is-flex-grow-1':''}>{ translate('Qui') }</span>
                                    {(option === 'qui')?
                                    <svg className="mr-s" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                                            <g transform="translate(-1645.000000, -92.000000)" stroke="#013F4C" strokeWidth="3">
                                                <g transform="translate(1656.957134, 104.000000) scale(1, -1) translate(-1656.957134, -104.000000) translate(1647.000000, 94.000000)">
                                                    <path d="M0,0 C12.6095123,13.3333333 18.9142684,20 18.9142684,20 C18.9142684,20 12.6095123,13.3333333 0,0 Z"></path>
                                                    <path d="M1,0 C13.6095123,13.3333333 19.9142684,20 19.9142684,20 C19.9142684,20 13.6095123,13.3333333 1,0 Z" transform="translate(10.457134, 10.000000) scale(-1, 1) translate(-10.457134, -10.000000) "></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    : ''}
                                </Link>
                            </li>
                            <li key="on" className={(option === 'on')?'current is-size-6-mobile':''}>
                                <Link to="/terms/on" className="is-flex is-align-items-center">
                                    <svg className="mr-xs" width="41px" height="40px" viewBox="0 0 41 40" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                            <g transform="translate(-471, -246)" fill="#809fa5">
                                                <g transform="translate(471, 246)">
                                                    <path d="M8.88508805,19.9914481 L8.88508805,28.8765361 L17.7701761,28.8765361 L17.7701761,19.9914481 L8.88508805,19.9914481 Z M15.5489041,26.6552641 L15.5489041,22.2127201 L11.1063601,22.2127201 L11.1063601,26.6552641 L15.5489041,26.6552641 Z"></path>
                                                    <path d="M14.4382681,0 C11.5431732,0 9.07933828,1.84617691 8.15973167,4.42546244 L0,4.42546244 L0,7.18159454 L4.44254402,10.5475991 L4.44254402,37.7616242 L1.11063601,37.7616242 C0.497253952,37.7616242 0,38.2588559 0,38.8722602 C0,39.4856645 0.497253952,39.9828962 1.11063601,39.9828962 L4.44254402,39.9828962 L4.44254402,40 L35.5403522,40 L35.5403522,39.9828962 L38.8722602,39.9828962 C39.4856645,39.9828962 39.9828962,39.4856645 39.9828962,38.8722602 C39.9828962,38.2588559 39.4856645,37.7616242 38.8722602,37.7616242 L35.5403522,37.7616242 L35.5403522,10.5866935 L40.5382142,7.22068893 L40.5382142,4.42546244 L20.7168045,4.42546244 C19.7971979,1.84617691 17.333363,0 14.4382681,0 Z M20.722913,8.88508805 C20.9684746,8.19027416 21.1020841,7.44270507 21.1020841,6.66381603 L21.1020841,6.64671224 L37.4139951,6.64671224 L34.0905279,8.88508805 L20.722913,8.88508805 Z M19.4052544,11.1063601 C18.1851097,12.4696658 16.4118683,13.3276321 14.4382681,13.3276321 C12.4646679,13.3276321 10.6914264,12.4696658 9.47128173,11.1063601 L6.66381603,11.1063601 L6.66381603,37.7616242 L19.9914481,37.7616242 L19.9914481,19.9914481 L31.0978082,19.9914481 L31.0978082,37.7616242 L33.3190802,37.7616242 L33.3190802,11.1063601 L19.4052544,11.1063601 Z M7.77445204,6.66381603 C7.77445204,7.44270507 7.90806155,8.19027416 8.15362317,8.88508805 L5.92646479,8.88508805 L2.97223965,6.64671224 L7.77445204,6.64671224 L7.77445204,6.66381603 Z M15.5489041,5.55318003 L15.5489041,3.33190802 L13.3276321,3.33190802 L13.3276321,5.55318003 L11.1063601,5.55318003 L11.1063601,7.77445204 L13.3276321,7.77445204 L13.3276321,9.99572405 L15.5489041,9.99572405 L15.5489041,7.77445204 L17.7701761,7.77445204 L17.7701761,5.55318003 L15.5489041,5.55318003 Z M28.8765361,22.2127201 L28.8765361,37.7616242 L22.2127201,37.7616242 L22.2127201,22.2127201 L28.8765361,22.2127201 Z"></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    <span className={(option === 'on')?'is-flex-grow-1':''}>{ translate('On') }</span>
                                    {(option === 'on')?
                                    <svg className="mr-s" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                                            <g transform="translate(-1645.000000, -92.000000)" stroke="#013F4C" strokeWidth="3">
                                                <g  transform="translate(1656.957134, 104.000000) scale(1, -1) translate(-1656.957134, -104.000000) translate(1647.000000, 94.000000)">
                                                    <path d="M0,0 C12.6095123,13.3333333 18.9142684,20 18.9142684,20 C18.9142684,20 12.6095123,13.3333333 0,0 Z"></path>
                                                    <path d="M1,0 C13.6095123,13.3333333 19.9142684,20 19.9142684,20 C19.9142684,20 13.6095123,13.3333333 1,0 Z" transform="translate(10.457134, 10.000000) scale(-1, 1) translate(-10.457134, -10.000000) "></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    : ''}
                                </Link>
                            </li>
                            <li key="quan" className={(option === 'quan')?'current is-size-6-mobile':''}>
                                <Link to="/terms/quan" className="is-flex is-align-items-center">
                                    <svg className="mr-xs" version="1.1" x="0px" y="0px" width="40px" height="40px" viewBox="0 0 39.8 39.8">
                                        <g transform="translate(-251, -240)">
                                            <g transform="translate(251, 240)" fill="#809fa5">
                                                <path d="M4.4,18.8c0-1.2,1-2.2,2.2-2.2h2.2c1.2,0,2.2,1,2.2,2.2V21c0,1.2-1,2.2-2.2,2.2H6.6c-1.2,0-2.2-1-2.2-2.2V18.8z M8.9,18.8V21H6.6v-2.2H8.9z" />
                                                <path d="M15.5,16.6c-1.2,0-2.2,1-2.2,2.2V21c0,1.2,1,2.2,2.2,2.2h2.2c1.2,0,2.2-1,2.2-2.2v-2.2c0-1.2-1-2.2-2.2-2.2H15.5z M17.7,18.8h-2.2V21h2.2V18.8z" />
                                                <path d="M22.1,18.8c0-1.2,1-2.2,2.2-2.2h2.2c1.2,0,2.2,1,2.2,2.2V21c0,1.2-1,2.2-2.2,2.2h-2.2c-1.2,0-2.2-1-2.2-2.2V18.8z M24.3,18.8h2.2V21h-2.2V18.8z" />
                                                <path d="M6.6,25.5c-1.2,0-2.2,1-2.2,2.2v2.2c0,1.2,1,2.2,2.2,2.2h2.2c1.2,0,2.2-1,2.2-2.2v-2.2c0-1.2-1-2.2-2.2-2.2H6.6z M6.6,27.7v2.2h2.2v-2.2H6.6z" />
                                                <path d="M13.3,27.7c0-1.2,1-2.2,2.2-2.2h2.2c1.2,0,2.2,1,2.2,2.2v2.2c0,1.2-1,2.2-2.2,2.2h-2.2c-1.2,0-2.2-1-2.2-2.2V27.7z M15.5,27.7h2.2v2.2h-2.2V27.7z" />
                                                <path d="M32.1,28.2c0.6,0,1.1,0.5,1.1,1.1v2.3l0.8,0.8c0.4,0.4,0.4,1.1,0,1.6s-1.1,0.4-1.6,0L31,32.6v-3.2C31,28.7,31.5,28.2,32.1,28.2z" />
                                                <path d="M6.6,1.1C6.6,0.5,7.1,0,7.7,0s1.1,0.5,1.1,1.1v5.5c0,0.6-0.5,1.1-1.1,1.1S6.6,7.3,6.6,6.6V5.5H3.3C2.7,5.5,2.2,6,2.2,6.6v4.4H31V6.6c0-0.6-0.5-1.1-1.1-1.1h-3.3V3.3h3.3c1.8,0,3.3,1.5,3.3,3.3v17.8c3.8,0.5,6.6,3.8,6.6,7.7c0,4.3-3.5,7.7-7.7,7.7c-2.6,0-5-1.3-6.4-3.3H3.3C1.5,36.5,0,35,0,33.2V6.6c0-1.8,1.5-3.3,3.3-3.3h3.3V1.1z M24.3,32.1c0-3.9,2.9-7.1,6.6-7.7V13.3H2.2v19.9c0,0.6,0.5,1.1,1.1,1.1h21.3C24.5,33.6,24.3,32.9,24.3,32.1z M32.1,37.6c3.1,0,5.5-2.5,5.5-5.5c0-3.1-2.5-5.5-5.5-5.5c-3.1,0-5.5,2.5-5.5,5.5C26.6,35.2,29,37.6,32.1,37.6z" />
                                                <path d="M23.2,7.7c-0.6,0-1.1-0.5-1.1-1.1V5.5H11.1V3.3h11.1V1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1v5.5C24.3,7.3,23.9,7.7,23.2,7.7z" />
                                            </g>
                                        </g>
                                    </svg>
                                    <span className={(option === 'quan')?'is-flex-grow-1':''}>{ translate('Quan') }</span>
                                    {(option === 'quan')?
                                    <svg className="mr-s" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                                            <g transform="translate(-1645.000000, -92.000000)" stroke="#013F4C" strokeWidth="3">
                                                <g transform="translate(1656.957134, 104.000000) scale(1, -1) translate(-1656.957134, -104.000000) translate(1647.000000, 94.000000)">
                                                    <path d="M0,0 C12.6095123,13.3333333 18.9142684,20 18.9142684,20 C18.9142684,20 12.6095123,13.3333333 0,0 Z"></path>
                                                    <path d="M1,0 C13.6095123,13.3333333 19.9142684,20 19.9142684,20 C19.9142684,20 13.6095123,13.3333333 1,0 Z" transform="translate(10.457134, 10.000000) scale(-1, 1) translate(-10.457134, -10.000000) "></path>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    : ''}
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div className={(loadingTerm || (selectedTerm && ((selectedTerm.combina && selectedTerm.combina.length > 0) || (selectedTerm.fragments && selectedTerm.fragments.length > 0)))) ? 'columns is-multiline is-flex is-flex-direction-row-reverse term-columns':'columns'}>
                { selectedTerm !== null ?
                <Lateral term={selectedTerm} showMap="true" closeCallback={setSelectedTerm}></Lateral>
                : loadingTerm ?
                <div className="column is-6-desktop is-12-touch">
                    <div className="is-flex is-justify-content-center">
                        <div className="loader white"></div>
                    </div>
                </div>
                : '' }

                <div className="column pb-l  pr-l-desktop is-6-desktop is-12-touch  h-100">
                    { data ?
                    <ul className="subthemes column ml-0-desktop p-0 m-0">
                        { data.map(res => {
                            return <TermTree key={res.term_id} option={option} term={res} level={0} updateTerm={updateSelectedTerm} resetChilds={resetChilds} showChildTerm={showChildTerm}></TermTree>
                        })}
                    </ul>
                    :'' }
                </div>


            </div>
        </div>

        </LayoutDefaultDark>
    )
}
